import {BaseContainerModel} from '../base-container.model';
import { bl_fi_intercompany_auto_purchase_stock_location_config_RowInterface, bl_fi_intercompany_auto_purchase_stock_location_config_RowClass } from '../../dbschema';

export class IntercompanyAutoPurchaseStockLocationConfigContainer extends BaseContainerModel{
    bl_fi_intercompany_auto_purchase_stock_location_config: bl_fi_intercompany_auto_purchase_stock_location_config_RowInterface = new bl_fi_intercompany_auto_purchase_stock_location_config_RowClass();   
}
